import { jsx as l } from "react/jsx-runtime";
import "react";
var c = (r) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    d: "M29.727 6.273 4.92 16.065c-.998.456-1.336 1.369-.241 1.864L11.043 20l15.387-9.733c.84-.612 1.7-.449.96.223L14.175 22.739l-.415 5.183c.384.8 1.088.804 1.537.407l3.657-3.542 6.262 4.8c1.454.882 2.245.313 2.558-1.303l4.108-19.907c.426-1.989-.301-2.865-2.155-2.103Z"
  })
});
export {
  c as default
};
